import React, { Component } from 'react';
import { Spin, message } from 'antd';
import Title from '../Components/Title';
import Text from '../../../../basicElement/Text';
import compareFn from '../../Components/compareFn';
import TableC from '../../../../basicElement/TableC';
import EditableCell from '../../../../basicElement/EditableCell';
import Fetch from '../../../../../common/Fetch';
import API_URL from '../../../../../common/url';
import format from '../../../../shared/format';

class ThirdParty extends Component {
    state = {
        data: [
            { name: '通讯费', price: '32000', Number: '20', period: '3', editable: true },
            { name: '本地交通费', price: '32000', Number: '20', period: '3' },
            { name: '小计' },
        ],
        prevData: [],
        loading: false,
        canEdit: false,
    }

    componentDidMount() {
        const { editable } = this.props;
        this.setState({ canEdit: editable });
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.editable && this.props.editable) {
            this.setState({ canEdit: true });
        }
    }

    loadData = () => {
        this.setState({ loading: true });
        Fetch.post(API_URL.site.queryInvestigationSiteFee)
        .then(res => {
            const { datas, totalCount } = res;
            pagination.total = totalCount;
            this.setState({
                pagination,
                data: datas,
                loading: false,
            });
        })
        .catch(error => {
            console.log(error);
            this.setState({ loading: false });
        });
    }

    handleAdd = () => {
        const { data } = this.state;
        data.splice(data.length - 1, 0, {
            newAdd: true,
        });
        this.setState({ data });
    }

    handleDelete = (index, record) => {
        const { data } = this.state;
        data.splice(index, 1);
        this.setState({ data });
    }
    
    getColumns = () => {
        const { names, mode } = this.props;
        const { data, prevData, canEdit } = this.state;
        const len = data.length;
        const columns = [{
            title: '',
            dataIndex: 'name',
            key: 'name',
            width: 200,
            render: (text, record, index) => {
                const { newAdd } = record;
                if (index < len - 1) {
                    if (mode === 'compare') {
                        return compareFn(prevData, data, 'name');
                    } else {
                        return (
                            <div className="inlineBlock">
                                <EditableCell type="Input" editable={canEdit && newAdd} value={text} onChange={value => this.handleChange(value, index, 'name')} />
                            </div>
                        );
                    }
                } else {
                    return <strong>{text}</strong>;
                }
            }
        }, {
            title: names.role,
            dataIndex: 'role',
            key: 'role',
            width: 100,
            render: (text, record, index) => {
                const { newAdd } = record;
                if (index < len - 1) {
                    if (mode === 'compare') {
                        return compareFn(prevData, data, 'role');
                    } else {
                        return (
                            <div className="inlineBlock">
                                <EditableCell type="Input" editable={canEdit && newAdd} value={text} placeholder={names.inputPlaceholder} onChange={value => this.handleChange(value, index, 'role')} />
                            </div>
                        );
                    }
                }
            }
        }, {
            title: <Text asterisk={canEdit}>{names.price}<br/>{names.cmp}</Text>,
            dataIndex: 'price',
            key: 'price',
            width: 140,
            render: (text, record, index) => {
                const { newAdd, editable } = record;
                if (index !== len - 1) {
                    if (mode === 'compare') {
                        return compareFn(prevData, data, 'price');
                    } else {
                        return (
                            <div className="inlineBlock">
                                <EditableCell type="Number" editable={canEdit && (newAdd || editable)} value={text} config={{precision:2}} placeholder={names.inputPlaceholder} onChange={value => this.handleChange(value, index, 'price')} />
                            </div>
                        );
                    }
                }
            }
        }, {
            title: names.personNo,
            dataIndex: 'Number',
            key: 'Number',
            width: 100,
            render: (text, record, index) => {
                const { newAdd } = record;
                if (index !== len - 1) {
                    if (mode === 'compare') {
                        return compareFn(prevData, data, 'Number');
                    } else {
                        return (
                            <div className="inlineBlock">
                                <EditableCell type="Number" editable={canEdit && newAdd} value={text} placeholder={names.inputPlaceholder} onChange={value => this.handleChange(value, index, 'Number')} />
                            </div>
                        );
                    }
                }
            }
        }, {
            title: names.period,
            dataIndex: 'period',
            key: 'period',
            width: 100,
            render: (text, record, index) => {
                const { newAdd } = record;
                if (index !== len - 1) {
                    if (mode === 'compare') {
                        return compareFn(prevData, data, 'period');
                    } else {
                        return (
                            <div className="inlineBlock">
                                <EditableCell type="Number" editable={canEdit && newAdd} value={text} placeholder={names.inputPlaceholder} onChange={value => this.handleChange(value, index, 'period')} />
                            </div>
                        );
                    }
                }
            }
        }, {
            title: names.cost,
            dataIndex: 'cost',
            key: 'cost',
            width: 120,
            render: (text, record, index) => {
                if (index === len - 1) {
                    let total = 0;
                    data.forEach((item, index) => {
                        if (index < len - 1) {
                            total += (item.cost || 0) * 1;
                        }
                    });
                    return format('money', total);
                } else {
                    return <strong>{format('money', text)}</strong>;
                }
            }
        }, {
            title: names.otherRemarks,
            dataIndex: 'otherRemarks',
            key: 'otherRemarks',
            render: (text, record, index) => {
                if (mode === 'compare') {
                    return compareFn(prevData, data, 'otherRemarks');
                } else {
                    return (
                        <div className="inlineBlock">
                            <EditableCell type="Input" editable={canEdit} value={text} placeholder={names.inputPlaceholder} onChange={value => this.handleChange(value, index, 'otherRemarks')} />
                        </div>
                    );
                }
            }
        }];
        if (canEdit) {
            columns.push({
                title: '操作',
                dataIndex: 'operation',
                key: 'operation',
                width: 80,
                render: (text, record, index) => {
                    const { newAdd } = record;
                    if (newAdd) {
                        return <a onClick={() => this.handleDelete(index, record)}>删除</a>;
                    }
                }
            });
        }
        return columns;
    }

    handleChange = (value, index, key) => {
        const { data } = this.state;
        const target = data[index];
        target[key] = value;
        if (key === 'price') {
            const { price, Number, period } = target;
            target.cost = (price || 0) * Number * period;
        }
        this.setState({ data: [...data] });
    }

    save = (canEdit) => {
        if (!canEdit) {
            this.setState({ canEdit: true });
        } else {
            const { names } = this.props;
            const { data } = this.state;
            for (let i = 0; i < data.length - 1; i++) {
                const item = data[i];
                const { newAdd, editable, price, Number, period } = item;
                if ((newAdd || editable) && !price && price !== 0) {
                    message.warning(`${names.inputPlaceholder}${names.price} ${names.cmp}!`);
                    return;
                } else if (newAdd && !Number && Number !== 0) {
                    message.warning(`${names.inputPlaceholder}${names.personNo}!`);
                    return;
                } else if (newAdd && !period && period !== 0) {
                    message.warning(`${names.inputPlaceholder}${names.period}!`);
                    return;
                }
            }
            this.setState({ canEdit: false });
            // this.props.hasChange(false);
        }
    }

    render() {
        const { title, editable } = this.props;
        const { data, loading, canEdit } = this.state;
        return (
            <Spin spinning={loading}>
                <Title title={title} editable={editable} canEdit={canEdit} save={this.save} add={this.handleAdd} />
                <div style={{ paddingLeft: 10 }}>
                    <TableC
                        data={data}
                        columns={this.getColumns()}
                        className="quotation_thirdParty"
                    />
                </div>
            </Spin>
        );
    }
}

export default ThirdParty;


// WEBPACK FOOTER //
// ./src/components/quotation/Production/Detail/Table/ThirdParty.js